export const getBusinessSizeBucket = (count: Maybe<number>): Maybe<number> => {
  if (count == null || count < 0) {
    return null
  }
  if (count === 0) {
    return 0
  }
  return Math.pow(10, Math.floor(Math.log10(count)))
}
